import { Link } from 'react-router-dom';
import { Stethoscope } from 'lucide-react';
import { PageHeader } from '@/components/ui';
import { CatalogStatusCard } from '@/features/sync/CatalogStatusCard';
import { ManualImportPanel } from '@/features/media/ManualImportPanel';

/** Importação manual habilitável por ambiente (F17-T01). */
const MANUAL_IMPORT_ENABLED = import.meta.env.VITE_ENABLE_MANUAL_MEDIA_IMPORT !== 'false';

export function SettingsPage(): React.ReactElement {
  return (
    <>
      <PageHeader title="Ajustes" showConnection />

      <div className="flex flex-col gap-3 pb-6">
        <CatalogStatusCard />

        {MANUAL_IMPORT_ENABLED && <ManualImportPanel />}

        <Link
          to="/diagnostics"
          className="flex min-h-14 items-center gap-2 rounded-xl bg-slate-800 px-4 active:bg-slate-700"
        >
          <Stethoscope size={18} aria-hidden />
          <span className="flex-1">Diagnóstico</span>
        </Link>
      </div>
    </>
  );
}
